<template>
  <div>
    <fieldset class="row">
      <legend class="col-sm-12 mb-0"><h1 class="h3">Tell us about your ride.</h1></legend>
      <div class="col-sm-12">
        <p class="label"><sup>*</sup> required</p>
      </div>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-year" v-slot="{ errors }" slim>
          <b-form-group id="select-group-year" label="Year*" label-for="select-year">
            <b-form-select
              id="select-year"
              v-model="selected_year"
              aria-describedby="select-year-error"
              :options="options.year"
              :state="errors[0] ? false : null"
              v-remove-aria-required
              class="btn-double-outline btn-double-outline--normal"
            />
            <b-form-invalid-feedback id="select-year-error" v-if="errors.length">
              Error: Year is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-make" v-slot="{ errors }" slim>
          <b-form-group id="select-group-make" label="Make*" label-for="select-make">
            <b-form-select
              id="select-make"
              v-model="selected_make"
              aria-describedby="select-make-error"
              :options="options.make"
              :state="errors[0] ? false : null"
              v-remove-aria-required
              class="btn-double-outline btn-double-outline--normal"
            />
            <b-form-invalid-feedback id="select-make-error" v-if="errors.length">
              Error: Make is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-model" v-slot="{ errors }" slim>
          <b-form-group id="select-group-model" label="Model*" label-for="select-model">
            <b-form-select
              id="select-model"
              v-model="selected_model"
              aria-describedby="select-model-error"
              :options="options.model"
              :state="errors[0] ? false : null"
              v-remove-aria-required
              class="btn-double-outline btn-double-outline--normal"
            />
            <b-form-invalid-feedback id="select-model-error" v-if="errors.length">
              Error: Model is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="select-trim" v-slot="{ errors }" slim>
          <b-form-group id="select-group-trim" label="Trim*" label-for="select-trim">
            <b-form-select
              id="select-trim"
              v-model="selected_trim"
              aria-describedby="select-trim-error"
              :options="options.trim"
              :state="errors[0] ? false : null"
              v-remove-aria-required
              class="btn-double-outline btn-double-outline--normal"
            />
            <b-form-invalid-feedback id="select-trim-error" v-if="errors.length">
              Error: Trim is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: "VehcileInfo",
  data() {
    return {
      options: {
        year: [{ value: null, text: "Year", disabled: true }],
        make: [{ value: null, text: "Make", disabled: true }],
        model: [{ value: null, text: "Model", disabled: true }],
        trim: [{ value: null, text: "Trim", disabled: true }]
      }
    };
  },
  created() {
    this.fetchYears();
  },
  watch: {
    selected_year(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== "") {
        this.fetchMakes();
        this.validateStep();
      }
    },
    selected_make(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== "") {
        this.fetchModels();
        this.validateStep();
      }
    },
    selected_model(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== "") {
        this.fetchTrims();
        this.validateStep();
      }
    },
    selected_trim(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== "") {
        this.validateStep();
      }
    }
  },
  computed: {
    selected_year: {
      get() {
        return this.$store.state.Year;
      },
      set(value) {
        this.$store.dispatch("vehicleYear", {
          id: value,
          label: this.getOptionLabelById(value, this.options.year)
        });
      }
    },
    selected_make: {
      get() {
        return this.$store.state.Make;
      },
      set(value) {
        this.$store.dispatch("vehicleMake", {
          id: value,
          label: this.getOptionLabelById(value, this.options.make)
        });
      }
    },
    selected_model: {
      get() {
        return this.$store.state.Model;
      },
      set(value) {
        this.$store.dispatch("vehicleModel", {
          id: value,
          label: this.getOptionLabelById(value, this.options.model)
        });
      }
    },
    selected_trim: {
      get() {
        return this.$store.state.Trim;
      },
      set(value) {
        this.$store.dispatch("vehicleTrim", {
          id: value,
          label: this.getOptionLabelById(value, this.options.trim)
        });
      }
    }
  },
  methods: {
    getOptionLabelById(id, options) {
      if (!id) {
        return null;
      }
      try {
        return options.find(option => option.value === id).text;
      } catch (e) {
        return null;
      }
    },
    async fetchYears() {
      try {
        const path = "vehicleproxy/Years";
        const results = await this.axios.get(path);

        // Transform the new API format to match the expected dropdown format
        // New API returns: { Years: [2026, 2025, 2024, ...] }
        // We need: [{ text: "2026", value: "2026" }, ...]
        const yearOptions = results.data.Years.map(year => ({
          text: year.toString(),
          value: year.toString()
        }));

        this.options.year = [...this.options.year, ...yearOptions];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchMakes() {
      this.resetValues("makes");

      try {
        const path = "vehicleproxy/Makes";
        const params = {
          year: this.selected_year
        };
        const results = await this.axios.get(path, { params });

        // Transform the new API format to match the expected dropdown format
        // New API returns: [{ Id: 1, Make: "Acura" }, ...]
        // We need: [{ text: "Acura", value: "1" }, ...]
        const makeOptions = results.data.map(make => ({
          text: make.Make,
          value: make.Id.toString()
        }));

        this.options.make = [...this.options.make, ...makeOptions];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchModels() {
      this.resetValues("models");

      try {
        const path = "vehicleproxy/Models";
        const params = {
          year: this.selected_year,
          makeId: this.selected_make
        };
        const results = await this.axios.get(path, { params });

        // Transform the new API format to match the expected dropdown format
        // New API returns: [{ Id: 21, Model: "Giulia" }, ...]
        // We need: [{ text: "Giulia", value: "21" }, ...]
        const modelOptions = results.data.map(model => ({
          text: model.Model,
          value: model.Id.toString()
        }));

        this.options.model = [...this.options.model, ...modelOptions];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async fetchTrims() {
      this.resetValues("trims");

      try {
        const path = "vehicleproxy/Vehicles";
        const params = {
          year: this.selected_year,
          makeId: this.selected_make,
          modelId: this.selected_model
        };
        const results = await this.axios.get(path, { params });

        // Transform the new API format to match the expected dropdown format
        // New API returns: [{ "Id": 42758, "Vehicle": "A-Spec" }, ...]
        // We need: [{ text: "A-Spec", value: "42758" }, ...]
        const cleanTrimOptions = results.data.map(trim => ({
          text: trim.Vehicle,
          value: trim.Id.toString()
        }));

        this.options.trim = [...this.options.trim, ...cleanTrimOptions];
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    resetValues(step) {
      switch (step) {
        case "makes":
          this.options.make = [{ value: null, text: "Make", disabled: true }];
          this.options.model = [{ value: null, text: "Model", disabled: true }];
          this.options.trim = [{ value: null, text: "Trim", disabled: true }];
          this.$store.dispatch("vehicleMake", { id: null, label: null });
          this.$store.dispatch("vehicleModel", { id: null, label: null });
          this.$store.dispatch("vehicleTrim", { id: null, label: null });
          break;
        case "models":
          this.options.model = [{ value: null, text: "Model", disabled: true }];
          this.options.trim = [{ value: null, text: "Trim", disabled: true }];
          this.$store.dispatch("vehicleModel", { id: null, label: null });
          this.$store.dispatch("vehicleTrim", { id: null, label: null });
          break;
        case "trims":
          this.options.trim = [{ value: null, text: "Trim", disabled: true }];
          this.$store.dispatch("vehicleTrim", { id: null, label: null });
          break;
        default:
          break;
      }
    },
    validateStep() {
      this.$nextTick(() => this.$emit("onValidate", null));
    }
  }
};
</script>

<style scoped>
h1 {
  margin-bottom: 26px;
}
</style>
